import { Breadcrumb } from "@gull";
import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import {
  actionCharterFlight,
  deleteCharter,
  deleteCharterRow,
  getCharterFlightById,
  getcharterRequest,
  updateCharter,
} from "app/services/charterService";
import queryString from "app/services/queryStringService";
import config from "config.json";
import moment from "moment";
import Tooltip from "rc-tooltip";
import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Dropdown,
  DropdownButton,
  Form,
  Row,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Helmet } from "react-helmet";
import { MdDelete, MdEdit } from "react-icons/md";
import { NotificationManager } from "react-notifications";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DateModal from "./Components/List/DateModal";
import EditModal from "./Components/List/EditModal";
import { AiOutlineSetting } from "react-icons/ai";
const { timeFormat, dateFormat } = config;

const CharterFlightList = () => {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  // console.log({ canAdd, canView, canEdit, canDelete });

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showDateModal, setShowDateModal] = useState(false);
  const [dateModalDetails, setDateModalDetails] = useState(null);
  const [selectedId, setSelectedId] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const [flightData, setFlightData] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editedRow, setEditedRow] = useState({});
  const [originalRow, setOriginalRow] = useState({});
  const [expandedRowId, setExpandedRowId] = useState(null);
  const navigate = useNavigate();
  const getFligtById = async (id) => {
    const charterResponse = await getCharterFlightById(id);
    setDateModalDetails(charterResponse.data);
  };

  const getDateDetails = async (cell, id) => {
    setSelectedId(id);
    setShowDateModal(true);
    window.setTimeout(async () => {
      await getFligtById(id);
    }, 1);
  };
  const cancelEdit = () => {
    setEditingRowId(null);
    setEditedRow({});
    setOriginalRow({});
    setExpandedRowId(null);
  };
  const rowEdit = async (values) => {
    const payload = {
      id: values.id,
      flightDate: values.flightDate,
      departureTime: values.departureTime,
      arrivalTime: values.arrivalTime,
      seat: values.seat,
      pnr: values.pnr,
      adultBaseFare: values.adultBaseFare,
      adultYQ: values.adultYQ,
      adultTotalTaxPerSeat: values.adultTotalTaxPerSeat,
      childBaseFare: values.childBaseFare,
      childYQ: values.childYQ,
      childTotalTaxPerSeat: values.childTotalTaxPerSeat,
      infrantBaseFare: values.infrantBaseFare,
      infrantYQ: values.infrantYQ,
      infrantTotalTaxPerSeat: values.infrantTotalTaxPerSeat,
      isActive: values.isActive,
      refundable: values.refundable,
    };

    try {
      const data = await updateCharter(payload);
      if (data) {
        console.log(data);
        NotificationManager.success("Updated Successfully.");
      }
    } catch (error) {
      NotificationManager.error(error);
      console.log(error);
    } finally {
      // handleClose();
      cancelEdit();
      window.setTimeout(async () => {
        await getFligtById(selectedId);
      }, 1);
    }
  };
  const handleEdit = async (selectedDate) => {
    setShowEditModal(!showEditModal);
    const filteredFlightData = dateModalDetails?.charterFlights.filter(
      (item) =>
        new moment(item.flightDate).format("YYYY-MM-DD") === selectedDate,
    )[0];
    setFlightData(filteredFlightData);
  };

  const handleDelete = async (selectedDltId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      showLoaderOnConfirm: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const charterResponse = await deleteCharter(selectedDltId);
        if (charterResponse.status === "Success") {
          window.setTimeout(async () => {
            await getFligtById(selectedId);
          }, 1);
          Swal.fire("Deleted!", "Your data has been deleted.", "success");
        } else {
          Swal.fire("Deleted!", charterResponse.message, "error");
        }
      },
    });
  };

  const deleteRow = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",

      cancelButtonText: "No",
      showConfirmButton: true,

      showLoaderOnConfirm: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const charterResponse = await deleteCharterRow(id);

        if (charterResponse.status === "Success") {
          Swal.fire("Deleted!", "Series Flight  has been deleted.", "success");
          setPage(1);
          await loadCharterHistory();
        } else {
          Swal.fire("Deleted!", charterResponse.message, "error");
        }
      },
    });
  };

  const departTimeFormatter = (cell, row) => {
    return moment(row.departureTime, "hh:mm:ss").format(timeFormat);
  };

  const arrivalTimeFormatter = (cell, row) => {
    return moment(row.arrivalTime, "hh:mm:ss").format(timeFormat);
  };

  const createdByFormatter = (cell, row) => {
    return (
      <>
        <Row>
          <Col lg={12}>{row.member.memberFirstName}</Col>
          <Col lg={12}>({row.member.memberType})</Col>
        </Row>
      </>
    );
  };
  const updateStatus = async (row) => {
    Swal.fire({
      title: `Are you sure you want to
    ${!row.isDisabled == true ? "inactive" : "active"}
     the Series Flight?`,
      icon: "warning",
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      showCancelButton: true,
      cancelButtonText: "No",
      showConfirmButton: true,
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const requestData = { id: row.id, status: !row.isDisabled };

        const res = await actionCharterFlight(requestData);

        try {
          if (res.status === "Success") {
            NotificationManager.success(res.message);
            setTimeout(async () => {
              await loadCharterHistory();
            }, 10);
          } else {
            NotificationManager.error(res.message);
          }
        } catch (error) {
          NotificationManager.error(error);
        }
      },
    });
  };
  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item
            onClick={() => navigate(`/admin/flight/edit/${row.id}`)}
            disabled
          >
            <MdEdit className="text-primary me-4" />
            Edit
          </Dropdown.Item>
          <Dropdown.Item onClick={() => updateStatus(row)}>
            <AiOutlineSetting className="text-primary me-4"></AiOutlineSetting>{" "}
            {!row.isDisabled ? " Click to Inactive" : "Click to Active"}
          </Dropdown.Item>
          <Dropdown.Item
            disabled={!row.isDisabled}
            onClick={() => deleteRow(row.id)}
          >
            <MdDelete className="text-primary me-4" />
            Delete
          </Dropdown.Item>
        </DropdownButton>
      </>
    );
  };

  const DateFormatter = (cell, row) => {
    const dates = row.dates.split("|");

    if (dates.length > 1) {
      return (
        <>
          <span>
            {moment(dates[0]).format(dateFormat)} to{" "}
            {moment(dates[dates.length - 1]).format(dateFormat)}
          </span>{" "}
          <br />
          {canEdit && (
            <Button
              variant="link"
              size="sm"
              onClick={(e) => getDateDetails(e, row.id)}
            >
              View Dates
            </Button>
          )}
        </>
      );
    } else {
      return (
        <>
          <span>{dates[0]}</span> <br />
          {canEdit && (
            <Button
              variant="link"
              size="sm"
              onClick={(e) => getDateDetails(e, row.id)}
            >
              View Date
            </Button>
          )}
        </>
      );
    }
  };

  const handleDateClose = () => {
    setShowDateModal(false);
  };

  const EditModalClose = () => {
    setShowEditModal(false);
  };

  const columns = [
    {
      dataField: "tripType",
      text: "Trip Type",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDeparture.cityCode",
      text: "From",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDestination.cityCode",
      text: "To",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "dates",
      text: "Dates",
      headerStyle: () => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: DateFormatter,
    },
    {
      dataField: "pnr",
      text: "PNR",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "departureTime",
      text: "Departure Time",
      headerStyle: () => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: departTimeFormatter,
    },
    {
      dataField: "arrivalTime",
      text: "Arrival Time",
      headerStyle: () => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: arrivalTimeFormatter,
    },
    {
      dataField: "id",
      text: "Created By",
      headerStyle: () => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: createdByFormatter,
    },
    {
      dataField: "id",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];

  const rowStyle = () => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadCharterHistory = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getcharterRequest(query);
    const data = response.data.data;

    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setLoading(false);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
  };

  useEffect(() => {
    loadCharterHistory();
  }, [page, sizePerPage]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      {canAdd && (
        <Link
          className="btn btn-primary btn-md float-end"
          to="/admin/flight/add"
        >
          <i className="i-Add-User text-white me-2"></i> Create Series
        </Link>
      )}
      <Helmet>
        <title>Series Flight Request</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Series Flight Request" }]}
      ></Breadcrumb>
      <div className="row d-flex flex-row-reverse bd-highlight"></div>
      <HandyScroll>
        <div
          class="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={
              canDelete ? columns : columns.filter((x) => x.text !== "Delete")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>

      <DateModal
        showDateModal={showDateModal}
        handleClose={handleDateClose}
        selectedId={selectedId}
        dateModalDetails={dateModalDetails}
        setShowEditModal={setShowEditModal}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        showEditModal={showEditModal}
        rowEdit={rowEdit}
        cancelEdit={cancelEdit}
        editingRowId={editingRowId}
        originalRow={originalRow}
        editedRow={editedRow}
        expandedRowId={expandedRowId}
        setEditingRowId={setEditingRowId}
        setEditedRow={setEditedRow}
        setOriginalRow={setOriginalRow}
        setExpandedRowId={setExpandedRowId}
      />
      <EditModal
        refreshData={getFligtById}
        showEditModal={showEditModal}
        EditModalClose={EditModalClose}
        flightData={flightData}
        selectedId={selectedId}
      />
    </>
  );
};

export default CharterFlightList;
